export default {
  zh: {
    title: '第三方管理',
    info: {
      title: '第三方配置'
    },
    config: {
      title: '跳过配置'
    },
    payout: {
      title: '放款控制'
    },
    app: {
      title: '启用第三方'
    }
  },
  en: {
    title: 'Third Party',
    info: {
      title: 'Third Party Config'
    },
    config: {
      title: 'Skip Config'
    },
    payout: {
      title: 'Payout Control'
    },
    app: {
      title: 'Enabled Third Party'
    }
  },
  es: {
    title: 'Terceros',
    info: {
      title: 'Configuración de terceros'
    },
    config: {
      title: 'Configuración de omisión'
    },
    payout: {
      title: 'Control de desembolso'
    },
    app: {
      title: 'Terceros habilitados'
    }
  },
  ti: {
    title: 'บุคคลที่สาม',
    info: {
      title: 'การตั้งค่าบุคคลที่สาม'
    },
    config: {
      title: 'การตั้งค่าการข้าม'
    },
    payout: {
      title: 'การควบคุมการจ่ายเงิน'
    },
    app: {
      title: 'บุคคลที่สามที่เปิดใช้งาน'
    }
  }
}
